import { render } from "./Serial.vue?vue&type=template&id=147d8aaa&scoped=true"
import script from "./Serial.vue?vue&type=script&lang=ts"
export * from "./Serial.vue?vue&type=script&lang=ts"

import "./Serial.vue?vue&type=style&index=0&id=147d8aaa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-147d8aaa"

export default script